module.exports = __webpack_public_path__ + "static/media/Comme-des-Garcons-White-Converse-X-Play-Classic-Sneakers-Lyst_thumb.f8e4e58b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/sneakers/Comme-des-Garcons-White-Converse-X-Play-Classic-Sneakers-Lyst_thumb.png
// module id = 298
// module chunks = 0